module.exports = __webpack_public_path__ + "static/media/chewy_small_logo_1.44ad6b43.png";